import styled from '@emotion/styled'
import { Row, color, spacer } from 'stylist'

const StyledSection = styled(Row)`
  padding-bottom: ${spacer(7)};
  background: ${({ background, theme }) => color(background, { theme })};
`

export default StyledSection 



// WEBPACK FOOTER //
// ./src/routes/home/components/StyledSection.js